import { render, staticRenderFns } from "./FindClientsUserIcon.vue?vue&type=template&id=5b230c45&scoped=true"
import script from "./FindClientsUserIcon.vue?vue&type=script&lang=js"
export * from "./FindClientsUserIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b230c45",
  null
  
)

export default component.exports